// export const BaseURL = `https://api.international-robotchallenge.org`;
export const BaseURL = `https://apistaging.international-robotchallenge.org`;

export const applicationURL = `${BaseURL}/competetions/2/applications`;
export const categoriesURL = `${BaseURL}/competetions/2/categories`;
export const firstStageURL = `${BaseURL}/registeration`;
export const countriesURL = `${BaseURL}/registeration/countries`;
export const organizationsURL = `${BaseURL}/registeration/organizations`;
export const paymentURL = `${BaseURL}/payment`;
